"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListPropertyState = void 0;
var ListPropertyTranslateState_init_1 = require("@/pages/listProperty/states/ListPropertyTranslateState.init");
var ListPropertyExposureCard_init_1 = require("@/pages/listProperty/states/ListPropertyExposureCard.init");
var ListYourPropertySuccessCase_init_1 = require("@/pages/listProperty/states/ListYourPropertySuccessCase.init");
var ListYourPropertyTestimonial_init_1 = require("@/pages/listProperty/states/ListYourPropertyTestimonial.init");
var ListPropertyWizardStep_1 = require("@/pages/listProperty/states/ListPropertyWizardStep");
var ListPropertyCompareView_1 = require("@/pages/listProperty/states/ListPropertyCompareView");
var ListPropertyFormState_init_1 = require("@/pages/listProperty/states/ListPropertyFormState.init");
exports.defaultListPropertyState = {
    t: ListPropertyTranslateState_init_1.defaultListPropertyTranslateState,
    featureImage: 'https://ww2.okay.com/commoncontent/images/listproperty/topimage.jpg',
    welcomeYouTube: 'https://www.youtube.com/embed/tz8St3jOfyA',
    exposureSole: ListPropertyExposureCard_init_1.defaultListPropertyExposureCardSole,
    exposureStandard: ListPropertyExposureCard_init_1.defaultListPropertyExposureCardStandard,
    successCases: ListYourPropertySuccessCase_init_1.defaultListYourPropertySuccessCases,
    testimonials: ListYourPropertyTestimonial_init_1.defaultListYourPropertyTestimonials,
    popupActive: false,
    popupIndex: ListPropertyWizardStep_1.ListPropertyWizardStep.BASIC,
    compare: ListPropertyCompareView_1.ListPropertyCompareView.SOLE_AGENT,
    exposureActive: null,
    form: ListPropertyFormState_init_1.defaultListPropertyFormState,
    isFormSubmiting: false,
};
